import { render, staticRenderFns } from "./publish-approve-switch.vue?vue&type=template&id=77c5c22e"
import script from "./publish-approve-switch.vue?vue&type=script&lang=js"
export * from "./publish-approve-switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports